module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/column-pinning/column-pinning.component.css
// module id = ./src/app/examples/column-pinning/column-pinning.component.css
// module chunks = main